import CallHistoryRowComponent from './CallHistoryRow.component';

export * from './CallHistoryRow.component';
export default CallHistoryRowComponent;
